import { ActionFactoryParams } from '../../../../utilsDeprecated/ControlledComponent/ControlledComponent.types';
import { CalendarStateDeprecated } from '../../controller';
import { CalendarContext } from '../../../../utilsDeprecated/context/contextFactory';
import { SetSelectedMonth } from '../setSelectedMonth/setSelectedMonth';
import { WidgetComponents, WidgetElements } from '../../../../utilsDeprecated/bi/consts';
import { TriggeredByOptions } from '../../../../types/types';
import { bookingsCalendarClick } from '@wix/bi-logger-wixboost-ugc/v2';

export type OnMonthSelected = (localDateTime: string) => Promise<void>;

export function createOnMonthSelectedAction(
  {
    getControllerState,
    context: { biLogger },
  }: ActionFactoryParams<CalendarStateDeprecated, CalendarContext>,
  setSelectedMonth: SetSelectedMonth,
): OnMonthSelected {
  return async (localDateTime: string) => {
    await setSelectedMonth(localDateTime, TriggeredByOptions.MONTH_SELECTED);
    biLogger.report(
      bookingsCalendarClick({
        component: WidgetComponents.DATE_PICKER,
        element: WidgetElements.MONTH_ARROW,
      }),
    );
  };
}
